import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Receipt, User } from "lucide-react";
import { formatCash } from "../../utils/operatorConsoleHelpers";
import { formatPlacedAt, formatRelative, ticketStatusMeta } from "../../utils/bettorsDeskHelpers";
import TicketTape from "./TicketTape";

const TicketInspectPanel = ({
  ticket,
  ticketLoading,
  ticketError,
  bettorsPath,
}) => {
  if (!ticket) {
    return (
      <aside className="bd-detail bd-detail-empty">
        <div className="bd-detail-placeholder">
          <Receipt size={28} strokeWidth={1.5} />
          <strong>Select a ticket</strong>
          <p>Pick a ticket from the lane to inspect legs, fixtures, and payout.</p>
        </div>
      </aside>
    );
  }

  const meta = ticketStatusMeta(ticket.status);
  const legCount = Number(ticket.legCount) || 0;
  const isMulti = legCount > 1;

  return (
    <aside className="bd-detail">
      <header className="bd-detail-head">
        <div className="bd-detail-avatar bd-detail-avatar-ticket">
          <Receipt size={16} />
        </div>
        <div>
          <h2 className="tabular-nums">{formatCash(ticket.stake, { compact: true })} stake</h2>
          <p>
            {formatRelative(ticket.placedAt)} · {formatPlacedAt(ticket.placedAt)}
          </p>
        </div>
        <span className={`bd-tag bd-tag-${meta.tone}`}>{meta.label}</span>
      </header>

      <div className="bd-detail-stats">
        <div>
          <em>Max pay</em>
          <strong className="tabular-nums">
            {formatCash(ticket.potentialPayout, { compact: true })}
          </strong>
        </div>
        <div>
          <em>Odds</em>
          <strong className="tabular-nums">
            {Number(ticket.totalOdds) > 0 ? `${Number(ticket.totalOdds).toFixed(2)}×` : "—"}
          </strong>
        </div>
        <div>
          <em>Legs</em>
          <strong>{isMulti ? `${legCount} · Acca` : legCount || "—"}</strong>
        </div>
      </div>

      {ticket.username && bettorsPath ? (
        <Link to={bettorsPath} className="bd-bettor-link">
          <User size={14} />
          <span>{ticket.username}</span>
          <ArrowUpRight size={13} />
        </Link>
      ) : null}

      <TicketTape
        tickets={ticketLoading || ticketError ? [] : [ticket]}
        loading={ticketLoading}
        error={ticketError}
      />
    </aside>
  );
};

export default TicketInspectPanel;
